import { useHistory } from 'react-router-dom';
import { getUserProfile } from '../../helpers/userProfile';
import LogoCelciusColor from '../../assets/img/logos/LogoCelciusColor.svg';
import { useEffect, useState } from 'react';
import { SpringerLogo } from '~/icons';
import { getUserClientId } from '~/helpers/getClientsHelper';
import { MenuLink } from '../Menu';
import logoDielIcon from '../../assets/img/logos/LogoDielPowered.svg';
import logoutIcon from '../../assets/img/Logout.svg';
import settingsIcon from '../../assets/img/Settings.svg';

import posthog from 'posthog-js';
import { t } from 'i18next';
import { useDispatch } from 'react-redux';
import {
  Background, CreditosMobile, InfoHeader, LogoContainer, StyledLink,
} from '../MenuMobile/styles';

const ActionableWrapper = ({ children, onClick }) => (
  <button
    type="button"
    style={{
      width: '100%', background: 'none', border: 'none', padding: 0,
    }}
    onClick={onClick}
  >
    {children}
  </button>
);

export const MenuUserMobile = ({ setIsModalUserOpen }): JSX.Element => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [profile] = useState(getUserProfile);
  const [clientIds, setClientIds] = useState<number[] | null>(null);
  const menuLinkIsActive = (link: string) => history.location.pathname.includes(link);

  const logout = () => {
    localStorage.clear();
    posthog.reset();
    dispatch({ type: 'RESET_DATA' });
  };

  const principalItemsMenu = [
    {
      to: '/configuracoes',
      name: t('configuracoes'),
      altImage: 'config-icon',
      image: settingsIcon,
      isActive: menuLinkIsActive('/configuracoes'),
      onClick: () => {
        setIsModalUserOpen(false);
      },
    },
    {
      to: '/login',
      name: t('sair'),
      altImage: 'logout-icon',
      image: logoutIcon,
      isActive: false,
      onClick: () => {
        setIsModalUserOpen(false);
        logout();
      },
    },
  ];

  useEffect(() => {
    getUserClientId({ profile, setClientIds });
  }, []);

  return (
    <Background>
      <ActionableWrapper onClick={() => { setIsModalUserOpen(false); }}>
        <LogoContainer>
          <div style={{ width: '18px' }} />
          {/* 157 - Atacadão
          158 - Carrier */}
          <StyledLink style={{ paddingRight: '12px' }} to="/visao-geral">
            {
              (clientIds && clientIds?.filter((item) => (item !== 157 && item !== 158)).length !== 0 || profile.permissions.isAdminSistema) && <img src={LogoCelciusColor} alt="logoCelcius " />
            }
            {
              (clientIds && clientIds?.filter((item) => (item !== 157 && item !== 158)).length === 0 && !profile.permissions.isAdminSistema) && <SpringerLogo color="black" />
            }
          </StyledLink>
          <div style={{ width: '20px' }} />
        </LogoContainer>
      </ActionableWrapper>
      <InfoHeader>
        { t('CONTA') }
      </InfoHeader>

      {principalItemsMenu.map((item) => (
        <MenuLink
          key={item.to}
          menuToogle
          linkTo={item.to}
          image={item.image}
          altImage={item.altImage}
          name={item.name}
          isActive={item.isActive}
          visible
          click={item.onClick}
          isMobile
        />
      ))}
      <CreditosMobile>
        Powered by
        {' '}
        <img src={logoDielIcon} alt="diel logo" />
      </CreditosMobile>
    </Background>
  );
};
